import { useEffect } from 'react'

import { toast } from '@tribeplatform/react-ui-kit/Toast'

import { OTSM } from '../@types'

export const useOneTimeServerMessage = (otsm: OTSM) => {
  useEffect(() => {
    // Handling otsm
    if (otsm?.description) {
      toast({
        description: otsm.description,
        title: otsm.title || 'Error',
        status: otsm.status || 'error',
        duration: Infinity,
      })
    }
  }, [])
}
